import { render, staticRenderFns } from "./addgLlist.vue?vue&type=template&id=1c0dcd56&scoped=true&"
import script from "./addgLlist.vue?vue&type=script&lang=js&"
export * from "./addgLlist.vue?vue&type=script&lang=js&"
import style0 from "./addgLlist.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addgLlist.vue?vue&type=style&index=1&id=1c0dcd56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0dcd56",
  null
  
)

export default component.exports